import { ApiError } from '../live/api.ts';

/** One stage Start found unable to resolve, as the server's preflight named it. */
export interface PreflightIssue {
  stage: string;
  reason: string;
}

/**
 * Decode a 409 from Start into the preflight's issues, or undefined for any other failure.
 * Checked field by field: a half-read list would show a panel with nothing to fix in it.
 */
export function preflightIssuesOf(error: unknown): PreflightIssue[] | undefined {
  if (!(error instanceof ApiError) || error.status !== 409 || error.body === null) return undefined;
  const raw = error.body.preflight;
  if (!Array.isArray(raw)) return undefined;
  const issues = raw.flatMap((entry): PreflightIssue[] => {
    if (typeof entry !== 'object' || entry === null) return [];
    const row = entry as Record<string, unknown>;
    return typeof row.stage === 'string' && typeof row.reason === 'string' && row.reason.trim().length > 0
      ? [{ stage: row.stage, reason: row.reason }]
      : [];
  });
  return issues.length > 0 ? issues : undefined;
}
